import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconArrow2Down = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 13.81 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M13.527,17.705 L7.971,23.331 C7.790,23.718 7.331,24.000 6.901,24.000 C6.639,24.000 6.388,23.894 6.202,23.707 L0.275,17.705 C-0.111,17.315 -0.111,16.682 0.275,16.291 C0.661,15.901 1.286,15.901 1.672,16.291 L6.060,20.734 L6.060,1.000 C6.060,0.448 6.355,-0.000 6.901,-0.000 C7.447,-0.000 8.060,0.448 8.060,1.000 L8.060,20.412 L12.130,16.291 C12.516,15.901 13.141,15.901 13.527,16.291 C13.913,16.682 13.913,17.315 13.527,17.705 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconArrow2Down.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
